import React, { useEffect } from 'react';
import { Divider, Grid } from '@mui/material';
import { RenderedArticle } from '@components/Articles/RenderedArticle';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { articleContentAreaStyles } from '@components/styleObjects/ArticleContentArea';
import { breakpoints, colors } from '@web-for-marketing/react-ui';
import { useSetAtom } from 'jotai';
import { isProgressBarVisibleAtom } from '@atoms/navigation';
import { PressRelease } from '@models/pressRelease';
import { MediaReleaseIntheNews } from './MediaReleaseIntheNews';
import { ExternalResourceLink } from '@models/externalResourceLink';
import { MediaContact } from '@components/PressRoomHome/MediaContact';

const classes = {
    ...articleContentAreaStyles,
    mainContainer: {
        margin: '0',
        padding: '5.6rem 0',
        position: 'relative',
        background: colors.background.white,
        [`@media (max-width: ${breakpoints.lg})`]: {
            padding: '5.6rem 0',
        },
        [`@media (max-width: ${breakpoints.md})`]: {
            padding: '0 0 4rem 0',
        },
    },
    definitionContainer: {
        marginBottom: '4.8rem',
        [`@media (max-width: ${breakpoints.sm})`]: {
            marginBottom: '1.6rem',
        },
    },
    divider: {
        width: '100%',
    },
} as const;

interface MediaReleaseContentAreaProps {
    mediaRelease: PressRelease;
    inTheNews: ExternalResourceLink[];
}

export function MediaReleaseContentArea({ mediaRelease, inTheNews }: MediaReleaseContentAreaProps): React.ReactElement {
    const { mediaUrlPrefix } = useStaticValues();
    const setIsProgressBarVisible = useSetAtom(isProgressBarVisibleAtom);

    useEffect(() => {
        setIsProgressBarVisible(true);
    }, [setIsProgressBarVisible]);

    return (
        <Grid
            component='section'
            container
            css={classes.mainContainer}
            spacing={{ xs: 0, md: 7, lg: 8 }}
        >
            <Grid size={{ xs: 12, md: 8 }}>
                <RenderedArticle content={mediaRelease.htmlContent} mediaUrlPrefix={mediaUrlPrefix} />
                <Divider css={classes.divider}></Divider>
                <MediaContact />
            </Grid>
            {inTheNews.length ? <Grid size={{ xs: 12, md: 4 }}>
                <MediaReleaseIntheNews intheNews={inTheNews} />
            </Grid> : null}
        </Grid>
    );
}
